<template>
  <div class="locationShelve__wrapper">
    <div class="locationShelve__label"><b>{{ shelf.label }}</b></div>
    <div class="locationShelve">
      <Bin v-for="bin in shelf.bins" :key="bin.id" :bin="bin" @show-bin-items="handleShowBinItems($event)"/>
    </div>
  </div>
</template>

<script>
import Bin from '@/components/locations/map/Bin'

export default {
  name: 'Shelf',
  components: {
    Bin
  },
  props: {
    shelf: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleShowBinItems(requestData) {
      requestData.shelf = this.shelf
      this.$emit('show-bin-items', requestData)
    }
  }
}
</script>

<style scoped lang="scss">
.locationShelve__wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0 0 15px 0;
  background-color: rgba(118, 113, 189, 0.1);
  padding: 5px 10px 10px;

  .locationShelve__label {
    font-size: 14px;
    font-weight: 400;
    padding: 5px 5px 10px;
  }

  .locationShelve {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    > .locationBin {
      margin: 5px;
    }
  }
}
</style>
